var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilita(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.84,
    height: 34.619,
    viewBox: "0 0 15.568 9.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081c2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M96.088 148.796h-5.772v-1.755h5.772z",
    transform: "translate(-87.265 -140.636)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h.988a.27.27 0 0 0 .271-.271V-.43a.279.279 0 0 0-.071-.184c-.573-.639-1.212-.957-1.917-.957-.322 0-.619.065-.893.198a2.187 2.187 0 0 0-.711.539c-.2.229-.356.497-.471.808a2.864 2.864 0 0 0-.171.999c0 .342.052.667.156.973.102.306.249.577.437.813.19.234.417.42.685.555.267.135.561.204.882.204.406 0 .782-.101 1.127-.3.268-.155.49-.363.666-.624a.268.268 0 0 1 .381-.066l.67.495c.11.081.147.234.075.35-.25.409-.595.742-1.033 1-.509.299-1.121.448-1.833.448a3.52 3.52 0 0 1-1.465-.304 3.755 3.755 0 0 1-1.951-2.032 3.84 3.84 0 0 1-.283-1.469c0-.549.095-1.061.283-1.535.19-.473.446-.885.77-1.234.324-.35.706-.624 1.144-.823a3.364 3.364 0 0 1 1.406-.299c.626 0 1.192.183 1.697.549.175.126.42-.01.42-.226a.27.27 0 0 1 .27-.27h.678c.149 0 .271.121.271.27V.81c0 .149-.122.27-.271.27H0A.271.271 0 0 1-.271.81V.271C-.271.121-.149 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 5.56 2.7)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.149 0-.305-.03-.465-.091A1.981 1.981 0 0 1-.94-.353a2.668 2.668 0 0 1-.439-.401 2.472 2.472 0 0 1-.352-.518v.927c0 .15-.122.271-.271.271h-.774a.27.27 0 0 1-.271-.271v-5.061a.27.27 0 0 1 .271-.271h.891a.27.27 0 0 1 .271.271v3.051c0 .043.01.089.03.128.151.29.388.511.707.661.274.129.577.208.91.238a.273.273 0 0 1 .255.268v1.049A.565.565 0 0 1 .177 0Z",
    transform: "matrix(.35278 0 0 -.35278 7.906 1.694)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.273.273 0 0 0-.26.351 1.478 1.478 0 0 0 .399.654c.128.121.276.216.443.283.168.067.348.102.54.102A1.418 1.418 0 0 0 2.527.338.271.271 0 0 0 2.264 0Zm3.287 1.561a2.803 2.803 0 0 1-.92.63 3.008 3.008 0 0 1-1.223.236 3.09 3.09 0 0 1-1.235-.236 2.79 2.79 0 0 1-.935-.635 2.749 2.749 0 0 1-.588-.931 3.11 3.11 0 0 1-.203-1.128c0-.385.069-.752.208-1.101.138-.349.337-.656.593-.919.257-.264.567-.472.93-.625.363-.154.77-.23 1.219-.23.627 0 1.167.137 1.619.411.334.202.602.446.802.733a.273.273 0 0 1-.154.416l-.681.189a.265.265 0 0 1-.292-.106 1.158 1.158 0 0 0-.434-.387 1.648 1.648 0 0 0-.806-.209 1.5 1.5 0 0 0-.995.375 1.475 1.475 0 0 0-.423.671.273.273 0 0 0 .258.355H4.03c.014.057.023.128.027.213.004.086.005.175.005.268 0 .378-.066.741-.198 1.091a2.695 2.695 0 0 1-.577.919",
    transform: "matrix(.35278 0 0 -.35278 8.709 2.542)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.273.273 0 0 0-.261.351 1.478 1.478 0 0 0 .399.654 1.409 1.409 0 0 0 .983.385A1.416 1.416 0 0 0 2.526.338.27.27 0 0 0 2.263 0Zm3.286 1.561a2.809 2.809 0 0 1-.919.63c-.36.158-.768.236-1.224.236-.456 0-.868-.078-1.235-.236a2.79 2.79 0 0 1-.935-.635 2.764 2.764 0 0 1-.588-.931 3.11 3.11 0 0 1-.203-1.128c0-.385.069-.752.208-1.101.139-.349.337-.656.593-.919.257-.264.567-.472.93-.625.364-.154.77-.23 1.219-.23.627 0 1.167.137 1.62.411.334.202.601.446.801.733a.273.273 0 0 1-.153.416l-.682.189a.265.265 0 0 1-.292-.106 1.163 1.163 0 0 0-.433-.387 1.654 1.654 0 0 0-.807-.209 1.491 1.491 0 0 0-.995.375 1.455 1.455 0 0 0-.423.671.273.273 0 0 0 .258.355h4.003c.014.057.024.128.027.213.004.086.006.175.006.268 0 .378-.067.741-.199 1.091a2.695 2.695 0 0 1-.577.919",
    transform: "matrix(.35278 0 0 -.35278 10.968 2.542)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a1.384 1.384 0 0 1-.513.503c-.221.128-.507.192-.855.192-.492 0-.934-.099-1.325-.299a2.27 2.27 0 0 1-.456-.302.268.268 0 0 0-.443.205v.03a.27.27 0 0 1-.27.271h-.753a.27.27 0 0 1-.271-.271v-5.061a.27.27 0 0 1 .271-.271h.892a.27.27 0 0 1 .27.271v2.954a.28.28 0 0 0 .015.091c.049.154.123.295.22.426.108.142.227.265.359.368.131.104.272.184.421.241.15.057.296.086.439.086a.774.774 0 0 0 .652-.31c.157-.207.236-.535.236-.984v-2.872a.27.27 0 0 1 .27-.271h.892a.27.27 0 0 1 .27.271v3.225c0 .271-.023.538-.07.802C.205-.441.121-.206 0 0",
    transform: "matrix(.35278 0 0 -.35278 14.434 1.931)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081c2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.894.894 0 0 1-.619-.237.808.808 0 0 1-.27-.609c0-.235.093-.441.276-.609a.88.88 0 0 1 .616-.249c.228 0 .431.078.601.231a.768.768 0 0 1 .266.579.843.843 0 0 1-.277.659A.878.878 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 2.34 4.437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v3.686a.27.27 0 0 1-.27.27h-.892a.27.27 0 0 1-.27-.27V.549c0-.044-.01-.09-.031-.13a1.763 1.763 0 0 0-.605-.702 1.477 1.477 0 0 0-.807-.251c-.62 0-.931.43-.931 1.294v2.926a.27.27 0 0 1-.269.27h-.893a.27.27 0 0 1-.27-.27V.449c0-.726.15-1.275.449-1.646.3-.371.738-.556 1.315-.556.471 0 .902.097 1.293.289.393.193.713.481.962.865l.032-.449a.701.701 0 0 1 .285-.486c.16-.117.368-.176.625-.176a3.137 3.137 0 0 1 .62.064v.988c0 .109-.055.221-.156.262a.254.254 0 0 0-.106.076C.027-.256 0-.149 0 0",
    transform: "matrix(.35278 0 0 -.35278 5.895 5.466)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h.892a.27.27 0 0 1 .27.271v5.061a.271.271 0 0 1-.27.271H0a.272.272 0 0 1-.271-.271V.271C-.271.121-.149 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 6.492 6.047)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 2.669 3.202c.04.049.062.111.062.173v.509a.27.27 0 0 1-.27.27h-3.96a.271.271 0 0 1-.271-.27V3.42c0-.149.122-.271.271-.271H.645a.27.27 0 0 0 .207-.444L-1.835-.496a.274.274 0 0 1-.062-.174v-.508a.27.27 0 0 1 .27-.27h4.142a.27.27 0 0 1 .269.27v.465c0 .15-.12.27-.269.27H.208A.27.27 0 0 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 7.896 5.536)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081c2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.538.452-1.189.682-1.936.682-.72 0-1.309-.225-1.751-.666a2.185 2.185 0 0 1-.664-1.587c0-.541.132-.97.391-1.275.269-.314.59-.474.955-.474.247 0 .466.058.651.174a.657.657 0 0 1 .327.575c0 .114-.04.28-.234.422-.196.143-.402.187-.61.113-.025-.009-.127-.053-.232.117a.809.809 0 0 0-.109.438c0 .33.11.591.339.801.233.215.552.319.975.319a.925.925 0 0 0 .772-.374c.21-.269.313-.565.313-.906 0-.294-.061-.59-.18-.88-.117-.289-.408-.654-.863-1.085-.493-.463-.813-.844-.981-1.166a2.136 2.136 0 0 1-.257-.982c0-.429.044-.574.083-.653.078-.161.229-.249.424-.249.159 0 .53.073.53.753 0 .178.069.385.203.614.141.239.414.519.81.832.422.334.754.615.985.835.245.232.454.507.622.816.177.323.267.682.267 1.067C.83-1.047.551-.462 0 0",
    transform: "matrix(.35278 0 0 -.35278 3.238 1.91)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.184l-.674 1.883V-.523h-.308v3.214h.316L-.097.564l.763 2.127h.331V-.523H.676v2.406z",
    transform: "matrix(.35278 0 0 -.35278 3.766 7.7)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c.308 0 .44.129.44.464v1.764c0 .335-.132.463-.44.463s-.441-.128-.441-.463V.464C-.441.129-.308 0 0 0m-.019 2.99h.038c.486 0 .752-.22.752-.679V.381c0-.459-.266-.68-.752-.68h-.038c-.486 0-.752.221-.752.68v1.93c0 .463.266.679.752.679",
    transform: "matrix(.35278 0 0 -.35278 4.664 7.793)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.464v-1.222H0c.285 0 .396.138.396.413v.483C.396-.102.258 0 0 0m-.464.294h.445c.258 0 .396.101.396.326v.372c0 .276-.11.413-.396.413h-.445ZM.35.156c.297-.046.376-.29.376-.51v-.528c0-.377-.257-.634-.745-.634h-.775v3.215h.785c.487 0 .717-.257.717-.634V.661C.708.445.63.184.35.156",
    transform: "matrix(.35278 0 0 -.35278 5.492 7.35)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M93.277 147.387h.117v1.134h-.117z",
    transform: "translate(-87.265 -140.636)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-1.244v3.215h.33V.303H0Z",
    transform: "matrix(.35278 0 0 -.35278 6.854 7.885)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M94.336 147.387h.117v1.134h-.117z",
    transform: "translate(-87.265 -140.636)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.588v-2.916h-.33V0h-.584v.299H0Z",
    transform: "matrix(.35278 0 0 -.35278 7.93 6.857)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-.335 1.672L-.671 0Zm-.423 2.384-.468.592h.409l.317-.592ZM.055-.29h-.781l-.161-.794h-.321l.68 3.215h.395l.689-3.215h-.34z",
    transform: "matrix(.35278 0 0 -.35278 8.415 7.503)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a3.749 3.749 0 0 1-1.12 2.478c-.222.221-.46.407-.709.564-.06-.048-.115-.094-.179-.144-.451-.356-.619-.582-.68-.683a1.212 1.212 0 0 1-.11-.238c.248-.119.481-.273.687-.48.422-.422.663-.936.715-1.526a2.412 2.412 0 0 0-.292-1.383l-.418.419a.276.276 0 0 1-.388 0l-.603-.604a.273.273 0 0 1 0-.387l.417-.417a2.36 2.36 0 0 0-1.382-.284 2.345 2.345 0 0 0-1.525.705 2.41 2.41 0 0 0-.716 1.744c0 .675.241 1.258.715 1.733.206.207.432.358.67.476l-.001.047c0 .41.107.823.317 1.226.055.106.122.214.2.325a3.686 3.686 0 0 1-2.166-1.084A3.721 3.721 0 0 1-7.699-.234c-.011-1.055.367-1.972 1.121-2.727.692-.692 1.526-1.069 2.478-1.12a3.732 3.732 0 0 1 2.246.55.273.273 0 0 0 .338-.034l.391-.391a.275.275 0 0 1 .389.001l.593.602a.274.274 0 0 1-.001.387l-.38.38a.273.273 0 0 0-.033.34C-.143-1.583.044-.83 0 0",
    transform: "matrix(.35278 0 0 -.35278 3.695 4.652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081c2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a3.27 3.27 0 0 1-.549-.274c-.549.785-.992 1.441-1.002 1.456-.011.015-.025.027-.039.04l-.399.61c.267.229.656.484.925.47a.282.282 0 0 0 .22-.119c.101-.127.141-.247.123-.369-.03-.216-.24-.41-.319-.465l.001.001A.267.267 0 0 1-.733.913c.046.033.467.34.539.821.04.268-.041.537-.232.779a.819.819 0 0 1-.609.32c-.673.037-1.408-.688-1.49-.771a.268.268 0 0 1-.034-.333l.373-.57L-6.424-.46l-.348.478.904.492-.001.002a.244.244 0 0 1-.165.456l-.001.002-1.618-.322a.51.51 0 1 1 .23-.982c.016.006.03.016.046.023v-.001l.018.01.033.018.082.045.398-.546-.416-2.008a3.16 3.16 0 0 1-1.525-.186 3.17 3.17 0 0 1-1.775-1.679 3.173 3.173 0 0 1-.068-2.444 3.198 3.198 0 0 1 4.124-1.843A3.2 3.2 0 0 1-4.458-5.78l.745.105c.145-.012.296.008.442.064l.238-.721-.421-.133a.178.178 0 0 1 .107-.339l.96.304a.178.178 0 0 1-.106.339l-.371-.117-.245.745c.396.236.584.711.421 1.134a.874.874 0 0 1-.271.373l1.655 3.903.328-.473a3.198 3.198 0 0 1-.867-3.528 3.198 3.198 0 0 1 4.124-1.843 3.197 3.197 0 0 1 1.843 4.123A3.198 3.198 0 0 1 0 0m-6.422-1.365 2.011-2.755-.483-.229a3.186 3.186 0 0 1-1.847 1.445zm1.75-3.437c-.04.103-.085.202-.134.299l.355.168a.931.931 0 0 1-.116-.436Zm-.864.149-1.737-.824.388 1.877a2.486 2.486 0 0 0 1.349-1.053m-1.178-.754 1.266.599c.033-.063.063-.129.092-.197zm1.511-.108c.011-.062.018-.125.025-.188l-1.263-.18zm1.278 1.632-.554.76.353.111.278-.844a.784.784 0 0 1-.077-.027m-1.454-3.093A2.463 2.463 0 0 0-6.76-8.282a2.487 2.487 0 0 0-3.207 1.433 2.467 2.467 0 0 0 .053 1.901 2.46 2.46 0 0 0 1.381 1.306c.371.143.756.187 1.127.15l-.501-2.415a.263.263 0 0 1 .081-.25.266.266 0 0 1 .256-.06l.009.003.001-.006 2.395.339a2.463 2.463 0 0 0-.214-1.095m.857 1.663.11.033a.895.895 0 0 1 .298-.273l-.363-.051c-.01.097-.026.194-.045.291M-1.7.308l-1.751-4.13a.961.961 0 0 1-.221-.001l-.285.864.392.124a.178.178 0 0 1 .116.223.18.18 0 0 1-.223.116l-.961-.304a.151.151 0 0 1-.058-.033L-6.099-.906-1.874.708l.224-.326A.292.292 0 0 1-1.7.308m5.108-4.305a2.465 2.465 0 0 0-1.381-1.307A2.488 2.488 0 0 0-1.18-3.87a2.487 2.487 0 0 0 .615 2.691C.013-1.993.62-2.817.946-3.165a.267.267 0 0 1 .389.363c-.31.33-.904 1.14-1.475 1.945a2.487 2.487 0 0 0 3.601-1.24 2.47 2.47 0 0 0-.053-1.9",
    transform: "matrix(.35278 0 0 -.35278 13.06 4.857)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilita);
export default __webpack_public_path__ + "static/media/mobilita.da3a971770f97fbb66c8c9af4d887de8.svg";
export { ForwardRef as ReactComponent };